import styles from "./claimable-authenticator-v2.module.scss";

type SocialProofContent = {
  photoSrc: string;
  photoAlt: string;
  quote: string;
  name: string;
  approvalDetail: string;
  resultText: string;
};

const DEFAULT_TESTIMONIAL: SocialProofContent = {
  photoSrc: "/images/testimonials/sign_up_page_stock.jpg",
  photoAlt: "Jennifer, Claimable user",
  quote:
    '"It was amazing to actually have somebody on my side that was fighting for me...helping me make my quality of life better."',
  name: "Jennifer",
  approvalDetail: "Approved for Actemra",
  resultText: "Claimable helped Jennifer reverse her denial in just 5 days.",
};

const SocialProofPanel = () => {
  return (
    <div className={styles.socialProofPanel}>
      <img
        src="/images/social-proof-decoration.png"
        alt=""
        className={styles.socialProofDecoration}
        aria-hidden="true"
      />
      <div className={styles.socialProofCard}>
        <div className={styles.socialProofImageContainer}>
          <img
            src={DEFAULT_TESTIMONIAL.photoSrc}
            alt={DEFAULT_TESTIMONIAL.photoAlt}
            className={styles.socialProofImage}
          />
        </div>
        <div className={styles.testimonialContent}>
          <p className={styles.quoteText}>{DEFAULT_TESTIMONIAL.quote}</p>
          <div className={styles.testimonialAttribution}>
            <p className={styles.testimonialName}>{DEFAULT_TESTIMONIAL.name}</p>
            <p className={styles.testimonialDetail}>
              {DEFAULT_TESTIMONIAL.approvalDetail}
            </p>
          </div>
        </div>
      </div>
      <p className={styles.testimonialResult}>
        {DEFAULT_TESTIMONIAL.resultText}
      </p>
    </div>
  );
};

export default SocialProofPanel;
